import _asyncToGenerator from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pop from '@/mixin/pop';
var errorMap = {
  '-1011': '客态助力已满',
  // 您今日助力已达到上限~
  '-1014': '主态助力已满',
  // 好友助力已满~
  '-1017': '助力未发起'
};
export default {
  mixins: [pop],
  data: function data() {
    return {
      info: null
    };
  },
  props: {
    code: {
      type: Number,
      "default": 0
    }
  },
  computed: {
    tip: function tip() {
      var key = errorMap[this.code];
      return this.setting.分享助力错误信息[key];
    }
  },
  watch: {
    value: {
      handler: function handler(val) {
        if (val && this.mvuid) {
          this.getMasterInfo();
        }
      },
      immediate: true
    }
  },
  methods: {
    getMasterInfo: function getMasterInfo() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.commonService.getUserInfo(_this.mvuid)["catch"](function (e) {
                  _this.close();

                  return Promise.reject(e);
                });

              case 2:
                _this.info = _context.sent;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};